import type { FeaturePurchaseOfferDefinition } from "@slot/game-shell";

/** The Secret Bonus offer's id: the server contract (it rides `SpinRequest.requestedFeatureIdentifier` verbatim). */
export const SECRET_BONUS_OFFER_ID = "secret_bonus";

/**
 * The Secret Bonus offer (decision 51): more free spins than the Bonus Buy, unlisted — no card on the purchase panel,
 * only a tap on the Secret Bonus symbol opens it, while the symbol is on the board. Priced and gated like every offer:
 * the operator's `featurePriceMultipliersById` entry, without which the shell drops it and a tap opens nothing.
 */
export const SECRET_BONUS_OFFER: FeaturePurchaseOfferDefinition = {
  id: SECRET_BONUS_OFFER_ID,
  actionType: "bonus_buy",
  titleKey: "feature_purchase.secret_bonus.title",
  descriptionKey: "feature_purchase.secret_bonus.description",
  fallbackTitle: "Secret Bonus",
  fallbackDescription: "More free spins than the Bonus Buy. Only while the Secret Bonus is on the board.",
  iconPath: "symbols/SB",
  listed: false,
};
